<div>
    <h2>Cache e dati</h2>
    
    <div class="flex justify-between border-b-2 border-primary-200 py-2">
        <div class="flex flex-col mt-2">
            <h3>Pulisci cache</h3>
            <span class="mt-1">Pulisce la cache del browser per questa appilcazione, eseguire se non si
                vedeno gli ultimi aggiornamenti</span>
        </div>
        <div class="flex items-center">
            <button class="p-4 rounded-2xl bg-primary-50 hover:bg-primary-200 my-auto" (click)="clean()">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" viewBox="0 0 24 24"
                    stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round"
                    stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M4 7l16 0" />
                    <path d="M10 11l0 6" />
                    <path d="M14 11l0 6" />
                    <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                    <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                </svg>
            </button>
        </div>
    </div>
    
    <div class="flex justify-between py-2">
        <div class="flex flex-col mt-2">
            <h3>Pulisci tutti i dati</h3>
            <span class="mt-1">Pulisce tutti i dati del sito, <b>Attenzione: pulendo i dati verrà persa la
                    sessione e si dovrà rieffetuare il login</b></span>
        </div>
        <div class="flex items-center">
            <button class="p-4 rounded-2xl bg-primary-50 hover:bg-primary-200 my-auto" (click)="cleanAll()">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" viewBox="0 0 24 24"
                    stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round"
                    stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M4 7l16 0" />
                    <path d="M10 11l0 6" />
                    <path d="M14 11l0 6" />
                    <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                    <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                </svg>
            </button>
        </div>
    </div>

</div>    
